export enum ResponseCodes {
    TWO_FACTOR_AUTH_CONFIRMATION_REQUIRED = 43315,
    TWO_FACTOR_AUTH_LOGIN_REQUIRED = 43316,
    FLEET_OWNER_NOT_FOUND = 66610,
    FLEET_OWNER_NOT_APPROVED = 66614,
}
